import { defineComponent, reactive, watch ,getCurrentInstance} from "@vue/composition-api";
import './index.scss'
import _ from 'lodash'
import { LAST_TOPIC_WORD, NEXT_TOPIC_WORD } from "../../config";
const PageContent = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => { }
    },
    endBtnsWord: {
      type: String,
      default: '结束答题'
    }
  },
  setup(props, context) {
    const vm = getCurrentInstance()
    //i18n 国际化
    const tran = function (initParam) {
      return vm?.proxy.$t(initParam) as string
    }
    const { emit } = context;
    const state = reactive({
      editItem: _.cloneDeep(props.item), //编辑数据源
      errorText: ''
    })


    watch(() => props.item, (val) => {
      state.editItem = _.cloneDeep(val);
    }, {
      deep: true
    })

    const pageTopicClick = (type: number) => {
      emit('pageTopicClick', type);
    }
    //page-topic-content
    return () => {
      return (<div class={document.body.clientWidth>=1000?'page-topic-content':'one-page-one-topic-btns'}>
        {/* {
          state.editItem.topicSetting.isRollback && !state.editItem.isFirstPage && <el-button onClick={() => pageTopicClick(1)} size='small' type="success">
            <span domPropsInnerHTML={props.item.topicSetting.lastPageText || LAST_TOPIC_WORD}></span>
          </el-button>
        } */}
        {
          state.editItem.hasOwnProperty('isShowLastPage') && state.editItem.isShowLastPage && !state.editItem.isFirstPage && <el-button onClick={() => pageTopicClick(1)} size='small' class='last-page-btn' type="success">
            <span domPropsInnerHTML={props.item.topicSetting.lastPageText || LAST_TOPIC_WORD}></span>
          </el-button>
        }
        {
          !state.editItem.hasOwnProperty('isShowLastPage') && state.editItem.topicSetting.isRollback && !state.editItem.isFirstPage && <el-button onClick={() => pageTopicClick(1)} size='small' type="success">
            <span domPropsInnerHTML={props.item.topicSetting.lastPageText || LAST_TOPIC_WORD}></span>
          </el-button>
        }
        <el-button onClick={() => pageTopicClick(2)} size='small' type="success">
          <span domPropsInnerHTML={props.item.topicSetting.nextPageText || NEXT_TOPIC_WORD}></span>
        </el-button>
        {
          state.editItem.topicSetting.isAllowSubmit && <el-button onClick={() => pageTopicClick(3)} size='small' type="success" class='last-sub-btn'>
            <span>{props.endBtnsWord || tran('survy.push')}</span>
          </el-button>
        }
      </div>)
    }
  }
})
export default PageContent
